import {
  INSPECTION_FORM_TYPE_ACCEPTANCE,
  INSPECTION_FORM_TYPE_FINAL,
  INSPECTION_FORM_TYPE_MID,
  InspectionFormItem,
  InspectionFormType,
} from '../types/inspectionForm';
import {
  ACCEPTANCE_FORM_SAMPLE_MEMO,
  ACCEPTANCE_FORM_SAMPLE_TITLE,
} from '../components/product/acceptanceFormDefaults';
import {
  MID_FORM_SAMPLE_MEMO,
  MID_FORM_SAMPLE_TITLE,
} from '../components/product/midFormDefaults';
import {
  FINAL_FORM_SAMPLE_MEMO,
  FINAL_FORM_SAMPLE_TITLE,
} from '../components/product/finalFormDefaults';

/**
 * 프론트 고정 검사 양식 카탈로그.
 * 나중에 같은 배열에 템플릿을 추가하고, 등록 화면에서 key로 고르면 됩니다.
 * DB inspection_form 과 무관합니다.
 */
export interface StaticInspectionForm {
  /** 프론트 전용 키 (예: acceptance-default) */
  key: string;
  formType: InspectionFormType;
  title: string;
  memo?: string;
  /** 초기 검사항목. 비어 있으면 실행 화면에서 행 추가 */
  items: InspectionFormItem[];
}

export const STATIC_INSPECTION_FORMS: StaticInspectionForm[] = [
  {
    key: 'acceptance-default',
    formType: INSPECTION_FORM_TYPE_ACCEPTANCE,
    title: ACCEPTANCE_FORM_SAMPLE_TITLE,
    memo: ACCEPTANCE_FORM_SAMPLE_MEMO,
    items: [],
  },
  {
    key: 'mid-default',
    formType: INSPECTION_FORM_TYPE_MID,
    title: MID_FORM_SAMPLE_TITLE,
    memo: MID_FORM_SAMPLE_MEMO,
    items: [],
  },
  {
    key: 'final-default',
    formType: INSPECTION_FORM_TYPE_FINAL,
    title: FINAL_FORM_SAMPLE_TITLE,
    memo: FINAL_FORM_SAMPLE_MEMO,
    items: [],
  },
];

export function listStaticForms(formType: InspectionFormType): StaticInspectionForm[] {
  return STATIC_INSPECTION_FORMS.filter((f) => f.formType === formType);
}

export function getStaticForm(key: string): StaticInspectionForm | undefined {
  return STATIC_INSPECTION_FORMS.find((f) => f.key === key);
}

export function defaultStaticForm(formType: InspectionFormType): StaticInspectionForm {
  const list = listStaticForms(formType);
  if (list.length === 0) {
    throw new Error(`정적 양식이 없습니다: ${formType}`);
  }
  return list[0];
}
